module.exports = __webpack_public_path__ + "static/media/illus-sent.f46acd69.png";